module.exports = __webpack_public_path__ + "img/background-2.8e15ee79.png";